import { FunctionComponent } from 'react';
import styles from './VaccineApprovalsIsEmpty.module.scss';

type VaccineApprovalsEmptyTab = 'pending' | 'approved' | 'declined' | 'all';

interface VaccineApprovalsIsEmptyProps {
    selectedTab: VaccineApprovalsEmptyTab;
}

const EMPTY_STATE_BY_TAB: Record<VaccineApprovalsEmptyTab, { title: string; paragraphs: string[] }> = {
    pending: {
        title: 'No Vaccines To Approve',
        paragraphs: ['No Vaccines to Approve.', "You're all up to date!"]
    },
    approved: {
        title: 'No Vaccines Approved',
        paragraphs: ["You're all up to date!"]
    },
    declined: {
        title: 'No Vaccines Declined',
        paragraphs: ["You're all up to date!"]
    },
    all: {
        title: 'No Vaccines To Approve',
        paragraphs: ['No Vaccines to Approve.', "You're all up to date!"]
    }
};

const VaccineApprovalsIsEmpty: FunctionComponent<VaccineApprovalsIsEmptyProps> = ({ selectedTab }) => {
    const { title, paragraphs } = EMPTY_STATE_BY_TAB[selectedTab];

    return (
        <div className={styles.containerEmpty}>
            <img
                className={styles.imageEmpty}
                src="/images/memberships/clients-notfound.svg"
                alt={title}
                width={390}
                height={257}
            />
            <h2 className={styles.titleEmpty}>{title}</h2>
            <div className={styles.descriptionEmptyContainer}>
                {paragraphs.map(paragraph => (
                    <p
                        key={paragraph}
                        className={styles.descriptionEmpty}
                    >
                        {paragraph}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default VaccineApprovalsIsEmpty;
